import request from "@/utils/request";

// 首页数据
export function getIndex(params) {
  return request({
    url: "/api/index",
    method: "get",
    params,
  });
}

// 获取栏目树结构数据
export function getNavTreeData(params) {
  return request({
    url: "/api/getNavTreeData",
    method: "get",
    params,
  });
}

// 根据栏目id获取文章列表
export function getArticleList(params) {
  return request({
    url: "/api/getArticleList",
    method: "get",
    params,
  });
}

// 根据文章id获取文字信息
export function getArticleInfo(articleId) {
  return request({
    url: `/api/getArticleInfo/${articleId}`,
    method: "get",
  });
}

// 联系我们
export function getContact(params) {
  return request({
    url: `/api/contactus`,
    method: "get",
    params,
  });
}
